'use client'
import Image from 'next/image'
import GoldLinkButton from './GoldLinkButton'
import getSlickSettings from 'src/constants/slickSettings'
import dynamic from 'next/dynamic';
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { eventsSlides, homePageInfinteScrollSlides } from 'src/constants';
const Slider = dynamic(() => import('react-slick'), { ssr: true });

const OrgInfiniteCarousel = ({homePage = false , title, isShowButton = false }) => {
  const slides  = homePage ? homePageInfinteScrollSlides : eventsSlides
  const sliderSettings = getSlickSettings(null, 'infiniteCompamies')
  return (
    <section className='py-[48px] bg-rolzo-white px-[15px] md:px-0'>
      <div className='flex flex-col justify-center'>
        <p className='tracking-normal text-center font-light pt-4 pb-6'>
          {title}
        </p>
        <Slider {...sliderSettings} className='px-[0.6rem]'>
          {slides.map((slide, index) => (
            <div key={index} className='mb-4'>
              <Image
                src={slide.img}
                alt={`Organization logo ${index + 1}`}
                width={127}
                height={85}
                className='object-contain'
                loading="lazy"
              />
            </div>
          ))}
        </Slider>
        <div className='self-center'>
          {isShowButton && (
            <GoldLinkButton href='/clients' isCenteredHorizontally={true} text='Learn more' />
          )}
        </div>
      </div>
    </section>
  )
}

export default OrgInfiniteCarousel
